import { render, staticRenderFns } from "./checkboxTagGroup.vue?vue&type=template&id=28c05398&scoped=true&"
import script from "./checkboxTagGroup.vue?vue&type=script&lang=js&"
export * from "./checkboxTagGroup.vue?vue&type=script&lang=js&"
import style0 from "./checkboxTagGroup.vue?vue&type=style&index=0&id=28c05398&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c05398",
  null
  
)

component.options.__file = "checkboxTagGroup.vue"
export default component.exports